import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { notNil } from '../../../core/helpers/is-nil';
import styles from './table-footer-basic.module.scss';

type Props = {
  className?: string;
  children?: ReactNode;
  alignment?: 'left' | 'right';
};

export const TableFooterBasic: React.FC<Props> = ({ children, className, alignment }) => {
  const hasContent = notNil(children);
  return (
    <div
      role="columnheader"
      className={classNames(
        styles.root,
        { [styles.right]: alignment === 'right', [styles.hasContent]: hasContent },
        className,
      )}
    >
      {children}
    </div>
  );
};
